import React from "react";
import styles from "../styles/vinos.module.css";

export default function VinosFiltersBar({ q, onQ, sortBy, onSortBy }) {
    return (
        <div className={styles["filters-row"]}>
            <div className={styles["filters-bar"]}>
                <span className={styles["filters-label"]}>Filtros</span>
                <input
                    className={styles.input}
                    placeholder="Buscar por nombre, tipo o descripción…"
                    value={q}
                    onChange={(e) => onQ(e.target.value)}
                />
            </div>

            <div className={`${styles["filters-bar"]} ${styles["sort-bar"]}`}>
                <span className={styles["filters-label"]}>Ordenación</span>
                <select className={styles.input} value={sortBy} onChange={(e) => onSortBy(e.target.value)}>
                    <option value="nombre">Orden: Nombre</option>
                    <option value="tipo">Orden: Tipo</option>
                </select>
            </div>
        </div>
    );
}
